<template>
  <!-- 大额线下转账弹窗 -->
  <van-overlay :show="visible">
    <div class="EFT-popup">
      <div class="EFT-popup-main">
        <div class="EFT-popup-main_close">
          <van-icon @click="close" name="close" color="white" size="30px" />
        </div>
        <div class="EFT-popup-main_body">
          <div class="fs-18 header">
            <span>余额不足 , 请充值</span>
          </div>
          <div class="body fs-13">
            <div style="width:100%;font-size: 16px; display: flex;flex-direction: column;justify-content: center;align-items: center;margin-bottom: 10px;color: #ff7903; text-shadow: 2px 3px 1px white;">
              <strong>请线下转账至天安金交中心</strong>
              <strong>指定的对公账户</strong>
            </div>
            <span>
              <span style="font-weight: 600;">账号名称：</span>
              <span>天安（贵州省）互联网金融资产交易中心股份有限公司</span>
            </span>
            <br />
            <span>
              <span style="font-weight: 600;">银行账户：</span>
              <span>14320015321533000017</span>
            </span>
          </div>
          <div style="width: 100%; height: 1px; background-color: gray"></div>
          <div class="footer fs-15">
            <!-- <div class="btn" @click="onlineRecharge"><span>线上充值</span></div> -->
            <!-- <div style="width: 1px; height: 80%; background-color: gray"></div> -->
            <div class="btn offline" @click="offlineRecharge">
              <span>线下转账</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<script>
import { Overlay, Icon, Row, Col } from "vant"
import { mapGetters } from "vuex"
export default {
  name: "BlEft",
  model: {
    prop: "visible"
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "大额线下转账更方便"
    }
  },
  methods: {
    close() {
      this.$emit("update:visible", false)
    },
    offlineRecharge() {
      this.$router.push({
        name: "recharge_offline",
        query: { redirect: this.$route.fullPath }
      })
    },
    onlineRecharge() {
      if (this.userInfo.isBindCard) {
        this.$router.push({ name: "recharge_1" })
      } else if (this.userInfo.isAuthName) {
        this.$router.push({ name: "recharge_2" })
      } else {
        this.$router.push({ name: "recharge_3" })
      }
    }
  },
  components: {
    [Overlay.name]: Overlay,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col
  },
  computed: {
    ...mapGetters(["userInfo"])
  }
}
</script>

<style lang="less" scoped>
.EFT-popup {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  .EFT-popup-main {
    overflow: hidden;
    background-color: transparent;
    width: 300px;
    .EFT-popup-main_close {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;
    }
    .EFT-popup-main_body {
      height: 8rem;
      border-radius: 5px;
      background: url(../assets/img/eft/etf_bg.png);
      background-size: cover;
      display: flex;
      flex-direction: column;
      .header {
        flex: 2;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        letter-spacing: 3px;
      }

      .body {
        display: flex;
        flex: 5;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding: 0 0.4rem;
        letter-spacing: 0px;
      }

      .footer {
        display: flex;
        flex: 1.5;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .btn {
          display: flex;
          justify-content: center;
          width: 100%;
        }
        .offline {
          color: #fb8a26;
        }
      }
    }
  }
}
</style>
